<template>
    <div class="poster">
        <div class="title">
            <p>海报邮寄</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form
                    :inline="true"
                    :model="formInline"
                    class="demo-form-inline"
                >
                    <el-form-item>
                        <el-select
                            v-model="formInline.type"
                            placeholder="请选择"
                        >
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="活动名称" value="1"></el-option>
                            <el-option label="快递单号" value="2"></el-option>
                            <el-option label="联系人" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input
                            v-model="formInline.data"
                            placeholder="请输入查询条件"
                            clearable
                        ></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit"
                            >查 询</el-button
                        >
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="全部" name="0"></el-tab-pane>
                    <el-tab-pane label="未邮寄" name="1"></el-tab-pane>
                    <el-tab-pane label="已邮寄" name="2"></el-tab-pane>
                </el-tabs>
            </div>
            <div class="table">
                <el-table
                    :data="tableData"
                    style="width: 100%"
                    v-loading="tabload"
                >
                    <el-table-column
                        prop="id"
                        label="邮寄ID"
                        align="center"
                        width="80px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="title"
                        label="活动名称"
                        align="center"
                        width="240px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="receive_name"
                        label="联系人"
                        align="center"
                        width="120px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="receive_phone"
                        label="联系方式"
                        align="center"
                        width="180px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="express_no"
                        label="快递单号"
                        align="center"
                        width="180px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="receive_address"
                        label="邮寄地址"
                        align="center"
                        width="180px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态"
                        align="center"
                        width="140px"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.status == 1 ? "未邮寄" : "已邮寄" }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="create_time"
                        label="创建时间"
                        align="center"
                        width="200px"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="opt"
                        label="操作"
                        align="center"
                        width="200px"
                        fixed="right"
                    >
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link
                                    type="primary"
                                    @click="detail(scope.row.id)"
                                    >详情</el-link
                                >
                                <el-link
                                    type="primary"
                                    @click="postInfo(scope.row)"
                                    v-if="
                                        activeName != 2 && scope.row.status != 2
                                    "
                                    >邮寄</el-link
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <detail ref="refdetail"></detail>
        <postPoster ref="refPostPoster"></postPoster>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import detail from "./detail.vue";
import postPoster from "./postPoster.vue";
export default {
    components: { detail, postPoster },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            selType: 1,
            tableData: [],
            formInline: {
                type: "",
                data: "",
            },
            activeName: "0",
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            posterList: "commodity/posterList",
        }),
        postInfo(row) {
            console.log(row);
            this.$refs.refPostPoster.dialogVisible = true;
            this.$refs.refPostPoster.rowData = row;
        },
        detail(id) {
            this.$refs.refdetail.dialogVisible = true;
            this.$refs.refdetail.getTable(id);
        },
        getList(tag) {
            this.tabload = true;
            if (this.formInline.type != 0 && !this.formInline.data) {
                this.$message.warning("请填写活动名称！");
            }
            let opt = {
                token: this.getToken,
                type: this.formInline.type == 0 ? null : this.formInline.type, //0-忽略此条件 1-活动名称 2-快递单号 3-联系人
                data: this.formInline.data, //输入的数据
                status: this.activeName == 0 ? null : this.activeName, //状态 1-未邮寄 2-已邮寄
                page_size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
            };
            this.posterList(opt).then((res) => {
                this.tabload = false;
                if (res.code == 1) {
                    this.tableData = res.data.data;
                    this.total = res.data.total ? res.data.total : 0;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                type: "0",
                data: "",
            };
            this.getList(1);
        },
        handleClick() {
            // console.log(this.activeName);
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__active-bar {
        width: 120px;
    }

    ::v-deep .el-tabs__item {
        width: 120px;
        text-align: center;
        padding: 0;
    }

    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }

    .main {
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
</style>